import postRequest from '../../../../../../postRequest';

/**
 * Bulk upload product vat.
 *
 * @param {number} SourceId Source Id
 * @param {number} SiteId Site Id
 * @param {file} File Either a csv or excel file
*/
export default function postProductVatPluId({
  SourceId,
  SiteId,
  File,
}) {
  const endpoint = `/oc-product-bulkapi/v1/bulk-process/product-vat/plu-id/${SourceId}`;

  const body = new FormData();
  body.append('SiteId', SiteId);
  body.append('File', File);

  return new Promise((resolve, reject) => {
    postRequest(
      endpoint,
      body,
      'Product Vat (PLU)',
      'Started : Product Vat : PLU (Update)',
      {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      },
    )
      .then((response) => resolve(response))
      .catch((error) => reject(error));
  });
}
